export default [
  { id: 'shooting_location' },
  { id: 'client_name' },
  { id: 'requested_movie_time_and_number' },
  { id: 'publishing_media_types' },
  { id: 'delivery_of_goods' },
  { id: 'service_target' }
]
